module.exports = __webpack_public_path__ + "static/media/Collections-weddings-Mobile.4547e134.webp";